export const playImgDiameter = '18px';
